export default __webpack_public_path__ + "static/media/Formular-Bold.3ac101a5.eot";